<template>
  <div id="TopNav">
    <mu-appbar :z-depth="0"
               class="top_nav"
               :style="navStyle">
      <mu-flex>
        <mu-flex fill
                 align-items="center"
                 justify-content="center"
                 class="brand_info">
          <span>感知数据中心</span>
        </mu-flex>
      </mu-flex>
      <mu-flex slot="right"
               class="top_right"
               align-items="center">
        <mu-menu>
          <mu-button flat
                     small
                     color="grey"
                     style="text-transform: none;"
                     v-if="!$store.getters.avatar">
            <mu-icon value="account_circle"
                     left></mu-icon>{{$store.getters.name}}
          </mu-button>
          <mu-button flat
                     small
                     color="grey"
                     style="text-transform: none;"
                     v-else>
            <img :src="$store.getters.avatar"
                 style="width:24px;height:24px;border-radius:24px;margin-right:5px">
            {{$store.getters.name}}
          </mu-button>
          <mu-list slot="content"
                   class="profile_menu">
            <mu-list-item button
                          @click="openModifyPwd">
              <mu-icon value="lock_open"
                       style="margin-right:6px;"></mu-icon>
              <mu-list-item-title>修改密码</mu-list-item-title>
            </mu-list-item>
            <mu-list-item button
                          @click="logoutSystem">
              <mu-icon value="exit_to_app"
                       style="margin-right:6px;"></mu-icon>
              <mu-list-item-title>退出登录</mu-list-item-title>
            </mu-list-item>
          </mu-list>
        </mu-menu>
        <span class="divider_vert"></span>
        <span class="current_date" ref="currentTime">XX/XX/XXXX XX:XX:XX XX</span>
      </mu-flex>
    </mu-appbar>

    <el-dialog
      title="修改密码"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="40%">
      <el-form :model="form" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
        size="small">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" v-model="form.oldPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="form.newPassword" autocomplete="off"></el-input>
          <!-- <span class="help_text">必须包含数字，字母以及特殊字符且大于6位</span> -->
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="form.checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :loading="btnLoading" style="float: right" type="primary" @click="submitForm()" size="small">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import store from "@/vuex/store";
import { updatePassword } from "@/api/user"
import { DESencrypt } from '@/utils/aes'
export default {
  name: "TopNav",
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs["ruleForm"].validateField('checkPass');
        }
        callback();
      }
    };
    var oldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      openShowTip: false,
      showTipButton: false,
      navStyle: {},
      messageNumber: "0",
      activeTipStep: 0,
      selectLang: "",
      timer: null,
      webSocket: null,
      dialogVisible: false,
      form: {
        oldPassword: '',
        newPassword: '',
        checkPass: ''
      },
      rules: {
        newPassword: [
          { validator: validatePass, trigger: 'blur' },
        ],
        oldPassword: [
        { validator: oldPass, trigger: 'blur' }
        ],
        checkPass: [
        { validator: validatePass2, trigger: 'blur' }
        ]
      },
      btnLoading: false,
    }
  },
  props: {
    hasRefresh: {
      type: Boolean,
      default: false
    },
    refreshPage: {
      type: Function,
      default: null
    }
  },
  
  mounted () {
    if (store.state.lang == "zh-CN" || store.state.lang == "zh") {
      this.selectLang = store.state.lang;
    } else {
      this.selectLang = 'en';
    }
    this.timer = setInterval(() => {
      var currentDate = new Date();
      this.$refs.currentTime.innerHTML = this.formateCurrentDate(currentDate);
    }, 1000);
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var opacity = Math.abs(Math.round(scrollTop)) / 50;
      this.navStyle = {
        background: 'rgba(17,19,36,' + opacity + ')'
      }
    },
    menuExpand () {
      console.log(this.$store.state.menuExpand);
      this.$store.commit("change_menuExpand");
    },
    formateCurrentDate(time) {
      if (time == null) {
        return '';
      }
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      var str;
      if(h>12) {
          h -= 12;
          str = " PM";
      }else{
          str = " AM";
      }
      h = h < 10 ? "0" + h : h;
      d = d < 10 ? "0" + d : d;
      m = m < 10 ? "0" + m : m;
      mm = mm < 10 ? "0" + mm : mm;
      s = s < 10 ? "0" + s : s;
      var xy = m + "/" + d + "/" + y + " " + h + ":" + mm + ":" + s;
      xy += str;
      return xy;
    },
    openModifyPwd() {
      this.dialogVisible = true;
    },
    submitForm(){
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          updatePassword({
            userId: this.$store.getters.userId,
            oldPassword: DESencrypt(this.form.oldPassword),
            newPassword: DESencrypt(this.form.newPassword)
          }).then(res =>{
            if(res.code == 200){
              this.$toast.success('密码修改成功，请重新登录');
              setTimeout(() => {
                window.location.replace('/');
              }, 1200);
              this.dialogVisible = false;
            }else {
              this.$toast.error(res.message);
            }
            this.btnLoading = false;
          }).catch(err => {
            this.$toast.error('修改密码失败，稍后重试')
          });
        } else {
          return false;
        }
      });
    },
    logoutSystem () {
      this.$confirm('确定退出本系统', '提示', {
        okLabel: '确定',
        cancelLabel: '取消',
        type: "warning"
      }).then(res => {
        if (res.result) {
          this.$store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        }
      });
    }
  },
  destroyed() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }
  }
}
</script>
<style scoped>
.top_nav {
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  z-index: 199;
  height: 48px;
  background: transparent;
}
.brand_info {
  margin-left: 320px;
}
.brand_info span {
  font-size: 24px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  margin-left: 8px;
  font-family: 'title_blank';
}
.top_right {
  height: 80%;
  margin: 10% 0px;
  font-size: 12px !important;
}
.top_right .mu-button {
  font-size: 12px !important;
}
.current_date {
  font-size: 14px;
  font-family: DINCOND;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 17px;
  margin-right: 12px;
  margin-left: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/TopNav.vue